import { render, staticRenderFns } from "./BatchOperateRenew.vue?vue&type=template&id=4fc54825&scoped=true"
import script from "./BatchOperateRenew.vue?vue&type=script&lang=ts"
export * from "./BatchOperateRenew.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateRenew.vue?vue&type=style&index=0&id=4fc54825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc54825",
  null
  
)

export default component.exports